import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest, IFactoryResponse } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'
import useAxios from '@/services/api/useAxios'

const resource = 'apiUsers'

const listApiUsers = (axios: IFactoryFunctionRequest) => (): IFactoryResponse<any> => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}`,
  })
}

const createApiUser = (axios: IFactoryFunctionRequest) => (data: { username: string; scopes: string[] }): IFactoryResponse<any> => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}`,
    data,
  })
}

const updateApiUser = (axios: IFactoryFunctionRequest) => (userId: string, data: { scopes: string[] }): IFactoryResponse<any> => {
  return axios({
    method: EMethod.put,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/${userId}`,
    data,
  })
}

const regenerateToken = (axios: IFactoryFunctionRequest) => (userId: string): IFactoryResponse<any> => {
  return axios({
    method: EMethod.put,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/${userId}/regenerate-token`,
  })
}

const regeneratePassword = (axios: IFactoryFunctionRequest) => (userId: string): IFactoryResponse<any> => {
  return axios({
    method: EMethod.put,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/${userId}/regenerate-password`,
  })
}

const deleteApiUser = (axios: IFactoryFunctionRequest) => (userId: string): IFactoryResponse<any> => {
  return axios({
    method: EMethod.delete,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/${userId}`,
  })
}

const updateApiUserInfo = (axios: IFactoryFunctionRequest) => (userId: string, data: { username: string }): IFactoryResponse<any> => {
  return axios({
    method: EMethod.put,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/${userId}/info`,
    data,
  })
}

export default (axios: AxiosInstance) => ({
  listApiUsers: listApiUsers(useAxios(axios)),
  createApiUser: createApiUser(useAxios(axios)),
  updateApiUser: updateApiUser(useAxios(axios)),
  regenerateToken: regenerateToken(useAxios(axios)),
  regeneratePassword: regeneratePassword(useAxios(axios)),
  deleteApiUser: deleteApiUser(useAxios(axios)),
  updateApiUserInfo: updateApiUserInfo(useAxios(axios)),
})
